window.okeReviewsWidgetOnInit = function() {
  moveWaRButton();

  // Observe mutations for individual reviews
  var reviewMain = document.querySelector('.js-okeReviews-reviews-main');
  if (reviewMain) {
    var reviewObserver = new MutationObserver(moveReviewComponents);
    reviewObserver.observe(reviewMain, { childList: true });
    moveReviewComponents();
  }

  // Observe initial mutation to move navbar & add handlers for tab changes
  var navbar = document.querySelector('[data-oke-reviews-nav-bar]');
  var isOkeReviewsEmpty = document.querySelector('.is-okeReviews-empty');
  if (navbar && !isOkeReviewsEmpty) {
    var navbarObserver = new MutationObserver((mutations, observer) => {
      var reviewsTab = document.querySelector('#okeReviews-reviews-tab')
      var qandaTab = document.querySelector('#okeReviews-qanda-tab')
      if (reviewsTab) {
        reviewsTab.addEventListener('click', moveReviewsNavbar);
      }
      if(qandaTab) {
        qandaTab.addEventListener('click', moveQandaNavbar);
      }
      moveReviewsNavbar();
      observer.disconnect();
    });
    navbarObserver.observe(navbar, { childList: true });
  }
}

// Move navbar into reviews controls header
function moveReviewsNavbar() {
  var widgetNavbar = document.querySelector('.okeReviews-widgetNavBar');
  var reviewsControlsHeader = document.querySelector('.okeReviews-reviews-controls');

  if (reviewsControlsHeader) {
    reviewsControlsHeader.insertAdjacentElement('afterbegin', widgetNavbar);
  }
}

// Move navbar into Q&A controls header
function moveQandaNavbar() {
  var widgetNavbar = document.querySelector('.okeReviews-widgetNavBar');
  var reviewsControlsHeader = document.querySelector('.okeReviews-qandaWidget-header-controls');

  if (reviewsControlsHeader) {
    reviewsControlsHeader.insertAdjacentElement('afterbegin', widgetNavbar);
  }
}

// Move WaR button next to filter
function moveWaRButton() {
  var writeReviewButton = document.querySelector('.js-okeReviews-writeReview');
  var reviewsControlsHeader = document.querySelector('.okeReviews-reviews-controls');

  if (reviewsControlsHeader && writeReviewButton && !writeReviewButton.className.includes('is-okeReviews-hiddenButton')) {
    reviewsControlsHeader.insertAdjacentElement('afterbegin', writeReviewButton);
  }
}

// Move recommendation & voting elements for each review
function moveReviewComponents() {
  document.querySelectorAll('.okeReviews-reviews-review').forEach((review) => {
    var reviewRecommendation = review.querySelector('.okeReviews-review-recommendation');
    var reviewHelpful = review.querySelector('.js-okeReviews-reviewHelpful');
    var reviewPrimary = review.querySelector('.okeReviews-review-primary-grid-left');

    var reviewPrimaryBottom = document.createElement('div');
    reviewPrimaryBottom.className = 'okeReviews-review-primary-bottom';

    if (reviewPrimary) {
      reviewPrimaryBottom.insertAdjacentElement('beforeend', reviewRecommendation);
      reviewPrimaryBottom.insertAdjacentElement('beforeend', reviewHelpful);
      reviewPrimary.insertAdjacentElement('beforeend', reviewPrimaryBottom);
    }
  });
}
